export default function resolveImageUrl(path) {
    return path?.startsWith('/') ? `${process.env.REACT_APP_BASE_URL + path}` : path;
}
